/**
 * Re-exports the shared UnsavedChangesWarning component with a survey-specific default message.
 * Existing survey imports continue to work without changes.
 */

import * as React from 'react';
import {
	UnsavedChangesWarning as SharedUnsavedChangesWarning,
	UnsavedChangesWarningProps as SharedProps,
} from '../../../../../components-v2/UnsavedChangesWarning';

export type { SharedProps as UnsavedChangesWarningProps };

const DEFAULT_SURVEY_MESSAGE = 'To see the most recent changes in the live survey, please save this survey.';

export interface SurveyUnsavedChangesWarningProps extends Omit<SharedProps, 'message'> {
	message?: string;
}

export const UnsavedChangesWarning: React.FC<SurveyUnsavedChangesWarningProps> = ({
	message = DEFAULT_SURVEY_MESSAGE,
	...rest
}) => {
	return <SharedUnsavedChangesWarning message={message} {...rest} />;
};
